"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignalBase = exports.Signal = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var root_1 = require("./styled/root");

var Signal = function Signal(_a) {
  var __UIScope = _a.__UIScope,
      ariaLabel = _a["aria-label"],
      testID = _a["data-testid"],
      className = _a.className,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'default' : _b,
      _c = _a.type,
      type = _c === void 0 ? 'default' : _c,
      isHalo = _a.isHalo,
      isSonar = _a.isSonar,
      isInverse = _a.isInverse,
      label = _a.label;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Signal',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var isNotification = type === 'notification';
  var isInverseValid = isInverse && type === 'notification';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    "aria-label": ariaLabel,
    pattern: isNotification ? 'danger' : pattern,
    isHalo: isHalo,
    isSonar: isSonar,
    isNotification: isNotification,
    hasLabel: Boolean(label),
    isInverse: isInverseValid
  }, label && isNotification && react_1.default.createElement(ui_text_1.Text, {
    pattern: "captionExtraBold"
  }, label)), label && !isNotification && react_1.default.createElement(ui_text_1.Text, {
    pattern: "emphasis",
    ml: 1,
    color: "grey-600"
  }, label));
};

exports.SignalBase = Signal;
var SignalWithSpace = (0, ui_helper_with_space_1.withSpace)(Signal);
exports.Signal = SignalWithSpace;